import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { CheckoutService } from '../../../services';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'lib-ngx-aim-ffl-alert',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './ngx-aim-ffl-alert.component.html',
  styleUrl: './ngx-aim-ffl-alert.component.css'
})
export class NgxAimFflAlertComponent {
  dialogRef = inject(DynamicDialogRef);
  router = inject(Router);
  checkoutService = inject(CheckoutService);

  onCancelClick() {
    this.dialogRef.close();
    this.checkoutService.reset();
    this.router.navigateByUrl('/');
  }

  onAcceptClick() {
    this.dialogRef.close('accepted');
  }
}
